import React from 'react';
import ReactDev from '../images/ReactDev.png';

const ExperienceBox = ({ logo, company, role, date, desc }) => {
  return (
    <div className='timeline-item'>
      <div className='timeline-dot'>
        <img src={logo ? logo : ReactDev} alt={`${company} logo`} className='timeline-logo' />
      </div>
      <div className='timeline-content'>
        <div className='experience-header'>
          <h3 className='company-name'>{company}</h3>
          <span className='experience-date'>{date}</span>
        </div>
        <p className='experience-role'>{role}</p>
        <p className='experience-desc'>{desc}</p>
      </div>
    </div>
  );
};

export default ExperienceBox;
